var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticStyle: {
      width: "700px"
    },
    attrs: {
      model: _vm.form,
      "label-width": "100px",
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("所属客户")
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.nickName,
      callback: function ($$v) {
        _vm.nickName = $$v;
      },
      expression: "nickName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: _vm.$t("管理员名称"),
      prop: "nickName"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.structureId == 0 ? true : false,
      maxLength: 100
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("nickName");
      }
    },
    model: {
      value: _vm.form.nickName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "nickName", $$v);
      },
      expression: "form.nickName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      prop: "account",
      label: _vm.$t("管理员账号")
    }
  }, [_c("el-input", {
    attrs: {
      maxLength: 50
    },
    on: {
      input: function ($event) {
        return _vm.handleBlurTrim("account");
      }
    },
    model: {
      value: _vm.form.account,
      callback: function ($$v) {
        _vm.$set(_vm.form, "account", $$v);
      },
      expression: "form.account"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: _vm.$t("登录密码"),
      prop: "password"
    }
  }, [_c("el-input", {
    attrs: {
      maxLength: 16
    },
    on: {
      input: function ($event) {
        _vm.form.password = _vm.form.password.replace(/\s/g, "");
      }
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: _vm.$t("手机号"),
      prop: "mobile"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.structureId == 0 ? true : false
    },
    on: {
      input: function ($event) {
        _vm.form.mobile = _vm.form.mobile.replace(/[^\d]/g, "");
      }
    },
    model: {
      value: _vm.form.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_c("el-select", {
    staticStyle: {
      width: "90px"
    },
    attrs: {
      disabled: _vm.structureId == 0 ? true : false
    },
    on: {
      change: _vm.changeGlobalRoaming
    },
    model: {
      value: _vm.form.globalRoaming,
      callback: function ($$v) {
        _vm.$set(_vm.form, "globalRoaming", $$v);
      },
      expression: "form.globalRoaming"
    }
  }, _vm._l(_vm.globalRoamingOptionData, function (item) {
    return _c("el-option", {
      key: item.label,
      attrs: {
        value: item.label
      }
    }, [_vm._v(_vm._s(item.label) + "  " + _vm._s(_vm.$t(item.value)))]);
  }), 1)], 1)], 2)], 1), _c("el-form-item", {
    attrs: {
      label: _vm.$t("邮箱"),
      prop: "email"
    }
  }, [_c("el-input", {
    on: {
      input: function ($event) {
        return _vm.handleBlurTrim("email");
      }
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _vm.structureId != 0 ? _c("el-form-item", {
    attrs: {
      label: _vm.$t("账号架构"),
      prop: "structureId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterTreeNode: _vm.filterTreeOption,
      "show-search": "",
      "dropdown-style": {
        maxHeight: "400px",
        overflow: "auto"
      },
      placeholder: _vm.$t("请选择") + _vm.$t("架构"),
      "tree-default-expand-all": "",
      "tree-data": _vm.treeData,
      "replace-fields": {
        children: "children",
        key: "id",
        value: "id",
        title: "name"
      }
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.structureId,
      callback: function ($$v) {
        _vm.structureId = $$v;
      },
      expression: "structureId"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      type: "text"
    },
    on: {
      click: _vm.addStructureFun
    }
  }, [_vm._v(_vm._s(_vm.$t("添加部门")))])], 1)]) : _vm._e(), _vm.structureId != 0 ? _c("el-form-item", {
    attrs: {
      label: _vm.$t("选择角色"),
      prop: "roleIds"
    }
  }, [_vm.roleList.length != 0 ? _c("a-radio-group", {
    model: {
      value: _vm.form.roleIds,
      callback: function ($$v) {
        _vm.$set(_vm.form, "roleIds", $$v);
      },
      expression: "form.roleIds"
    }
  }, _vm._l(_vm.roleList, function (item) {
    return _c("a-radio", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1) : _vm._e()], 1) : _vm._e(), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("完成")))])], 1)], 1), _vm.structureShow ? _c("structure-model", {
    ref: "structureRef",
    on: {
      cancel: function ($event) {
        _vm.structureShow = false;
      },
      ok: _vm.getStructureFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };